import { render, staticRenderFns } from "./elemento_prodotto_nuovo_ordine.vue?vue&type=template&id=95323492&"
import script from "./elemento_prodotto_nuovo_ordine.vue?vue&type=script&lang=js&"
export * from "./elemento_prodotto_nuovo_ordine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemActionText } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VImg,VListItem,VListItemActionText,VListItemAvatar,VListItemContent,VListItemTitle})
